<script setup>
import {useUserStore} from "@/stores/user.js";
import {storeToRefs} from "pinia";

defineProps({
  size: {
    type: [Number, String],
    default: 50
  }
});

const userStore = useUserStore();
const {initials} = storeToRefs(userStore);
</script>

<template>
  <v-avatar :size="size" class="user-avatar">
    <span class="text-letter">{{ initials }}</span>
  </v-avatar>
</template>

<style lang="less" scoped></style>
